<template>
<SettingsServices :client="client" @updated="onSetupComplete"/>
</template>

<script>
import SettingsServices from '@/pages/client/Settings/Services'

export default {
    props: ['client', 'setupStatus'],
    components: {SettingsServices},
    data() {
        return {}
    },
    methods: {
        onSetupComplete() {
            this.$store.dispatch('START_LOADING')
            this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'services'}).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('refreshClient')
                this.$router.push({name: 'client-setup-companies'})
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
